import React from 'react';
import { GeneralGoalContainer } from './styles';
import { BarGraph } from '@gerdau/hefesto-mais-web';
import { Column } from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import { Button, Title } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { ELoyaltyRoutes } from '../../../loyalty.routes';
import { ApplicationState } from '../../../../../store';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import {
  IMonthlyCoins,
  IMonthlyGoal
} from '../../../../../store/ducks/loyalty/types';

interface IGeneralGoalProps {
  selectedRewardMonth?: IMonthlyCoins;
  selectedGoalMonth?: IMonthlyGoal;
}

const GeneralGoal: React.FC<IGeneralGoalProps> = ({
  selectedRewardMonth,
  selectedGoalMonth
}) => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const history = useHistory();

  const columns: Column[] = [
    {
      colors: {
        tone: '500',
        variant: 'primary'
      },
      dataKey: 'value',
      dataKeyTitle: 'Pontos Acumulados'
    }
  ];

  const baseData = loyalty.rewards.monthly_coins
    .map((item) => {
      const parsedDate = new Date(item.start_date);
      const monthInitials = format(parsedDate, 'MMMM', { locale: ptBR });
      return {
        month: monthInitials,
        value: item.coins,
        order: parsedDate
      };
    })
    .sort((item1, item2) => item1.order.getTime() - item2.order.getTime());

  const dataSource = baseData
    .map((item) => {
      return { month: item.month, value: item.value };
    })
    .slice(-5);

  const coinTotal = loyalty.rewards.total.total_coins;
  const coinTotalMessagePart1 = 'Você possui um total de';
  const coinTotalMessagePart2 = coinTotal.toLocaleString('pt-BR') + ' pontos';

  const canGetRewards = (): boolean => {
    return (
      selectedRewardMonth !== undefined &&
      selectedGoalMonth !== undefined &&
      selectedRewardMonth.coins >= selectedGoalMonth.target
    );
  };

  return (
    <GeneralGoalContainer>
      <div className="general-goal">
        <div className="goal-title">
          <Title level={3}>Meta Geral </Title>
        </div>
        <div className="line">
          <hr />
        </div>
        <div className="bar-graph-container">
          <BarGraph
            barDataKey="month"
            dataSource={dataSource}
            columns={columns}
            YAxisWidth={50}
          ></BarGraph>
        </div>
        <div className="redeemCTA">
          <div className="totalCoinsMessage">
            <Title level={5}>{coinTotalMessagePart1}</Title>
          </div>
          <div className="totalCoinsNumber">
            <Title level={4}>{coinTotalMessagePart2}</Title>
          </div>
          <Button
            name="redeemCoins"
            variant="secondary"
            disabled={!canGetRewards()}
            onClick={() => {
              if (canGetRewards()) {
                history.push(
                  `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_REWARDS}`
                );
              }
            }}
          >
            Resgatar pontos
          </Button>
        </div>
      </div>
    </GeneralGoalContainer>
  );
};

export default GeneralGoal;
